export type PageType = 'main' | 'compact' | 'default';

export type PageConfig = {
    type: PageType;
    background?: string;
};

/**
 * Configuration object that maps URL patterns to page configurations.
 * Add new patterns here when adding new page types.
 */
export const PAGE_PATTERNS: { pattern: RegExp; config: PageConfig }[] = [
    {
        pattern: /^\/?$/,
        config: {
            type: 'main',
        },
    },
    {
        pattern: /^\/recipes\/[^/]+\/?$/,
        config: {
            type: 'compact',
            background: 'bg-purple-light',
        },
    },
    {
        pattern: /^\/search\/?$/,
        config: {
            type: 'compact',
            background: 'bg-purple-light',
        },
    },
    {
        pattern: /^\/events\/?$/,
        config: {
            type: 'compact',
            background: 'bg-purple-light',
        },
    },
    {
        pattern: /^\/events\/[^/]+\/?$/,
        config: {
            type: 'compact',
            background: 'bg-purple-light',
        },
    },
    {
        pattern: /^\/events\/[^/]+\/register\/?$/,
        config: {
            type: 'compact',
            background: 'bg-purple-light',
        },
    },
    {
        pattern: /^\/resources\/?$/,
        config: {
            type: 'compact',
            background: 'bg-purple-light',
        },
    },
    {
        pattern: /^\/gallery\/?$/,
        config: {
            type: 'compact',
            background: 'bg-purple-light',
        },
    },
    {
        pattern: /^\/news\/?$/,
        config: {
            type: 'compact',
            background: 'bg-purple-light',
        },
    },
    {
        pattern: /^\/news\/[^/]+\/?$/,
        config: {
            type: 'compact',
            background: 'bg-purple-light',
        },
    },
    {
        pattern: /^\/resources\/?$/,
        config: {
            type: 'compact',
            background: 'bg-purple-light',
        },
    },
    {
        pattern: /^\/send\/?$/,
        config: {
            type: 'compact',
            background: 'bg-purple-light',
        },
    },
    {
        pattern: /^\/terms-and-conditions\/?$/,
        config: {
            type: 'compact',
            background: 'bg-purple-light',
        },
    },
    {
        pattern: /^\/privacy-policy\/?$/,
        config: {
            type: 'compact',
            background: 'bg-purple-light',
        },
    },
    {
        pattern: /^\/cookies-policy\/?$/,
        config: {
            type: 'compact',
            background: 'bg-purple-light',
        },
    },
    {
        pattern: /^\/recipes\/?$/,
        config: {
            type: 'default',
        },
    },
    {
        pattern: /^\/about\/?$/,
        config: {
            type: 'default',
        },
    },
];

const DEFAULT_PAGE_CONFIG: PageConfig = {
    type: 'default',
};

export const getPageConfig = (path: string): PageConfig => {
    if (!path) return PAGE_PATTERNS[0].config;

    const pathParts = path.split('/').filter(Boolean);

    let pathWithoutLocale = path;
    if (pathParts.length > 0 && pathParts[0].length === 2) {
        pathWithoutLocale = '/' + pathParts.slice(1).join('/');
    }

    const match = PAGE_PATTERNS.find(({ pattern }) => pattern.test(pathWithoutLocale));

    return match ? match.config : DEFAULT_PAGE_CONFIG;
};

export const getPageType = (path: string): string => {
    return getPageConfig(path).type;
};
